import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/AwardsPage.css";

// Helper component for an award item (image + caption)
const AwardItem = ({ image, caption, alt }) => (
  <div className="award-item">
    <img src={image} alt={alt || caption} />
    <p>{caption}</p>
  </div>
);

const AwardsPage = () => {
  // Data for Awards 2011 – 12 items
  const awards2011 = [
    {
      image: "/wp-content/uploads/2016/02/img_1.jpg",
      caption: "Presidential Export Awards for 2007 & 2008",
    },
    {
      image: "/wp-content/uploads/2016/02/img_2.jpg",
      caption: "Business Today Top 20 Awards 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_3.jpg",
      caption: "Engineering Excellence Award 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_4.jpg",
      caption: "National Business Excellence Awards 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_5.jpg",
      caption: "NCE Export Awards 2010",
    },
    {
      image: "/wp-content/uploads/2016/02/img_6.jpg",
      caption: "NCE Export Awards 2010",
    },
    {
      image: "/wp-content/uploads/2016/02/img_7.jpg",
      caption: "Geo Responsibility Awards 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_8.jpg",
      caption: "Best Corporate Citizens Award 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_9.jpg",
      caption: "Best Corporate Citizens Award 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_10.jpg",
      caption: "Annual Report Awards 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_11.jpg",
      caption: "CNCI Achiever Award 2011",
    },
    {
      image: "/wp-content/uploads/2016/02/img_12.jpg",
      caption: "CNCI Achiever Award 2011",
    },
  ];

  return (
    <>
      <Header />

      {/* Banner */}
      <section
        className="awards-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2016/02/banner.jpg')",
        }}
      ></section>

      <div className="awards-wrapper">
        <div className="center-container">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Awards</span>
          </div>

          <h1 className="page-title">Awards</h1>

          {/* Presidential Export Awards */}
          <div className="awards-section">
            <h2 className="section-title">Presidential Export Awards</h2>
            <div className="awards-grid two-cols">
              <img
                src="/wp-content/uploads/2016/02/DSC_3355.jpg"
                alt="Presidential Export Award 1"
              />
              <img
                src="/wp-content/uploads/2016/02/DSC_3357.jpg"
                alt="Presidential Export Award 2"
              />
            </div>
          </div>

          {/* Awards 2011 */}
          <div className="awards-section">
            <h2 className="section-title">Awards 2011</h2>
            <div className="awards-grid three-cols">
              {awards2011.map((item, idx) => (
                <AwardItem
                  key={idx}
                  image={item.image}
                  caption={item.caption}
                />
              ))}
            </div>
          </div>

          {/* Business Today - Top Twenty */}
          <div className="awards-section">
            <h2 className="section-title">
              Business Today - Top Twenty (2010 – 2009)
            </h2>
            <ul className="awards-list">
              <li>Placed in 6th position – Best Corporates in Sri Lanka</li>
            </ul>
          </div>

          {/* Best Corporate Citizen Award – 2010 */}
          <div className="awards-section">
            <h2 className="section-title">
              Best Corporate Citizen Award – 2010
            </h2>
            <div className="awards-image-wrapper">
              <img
                src="/wp-content/uploads/2016/02/best_corporate_citizen.jpg"
                alt="Best Corporate Citizen Award 2010"
              />
            </div>
            <ul className="awards-list">
              <li>
                Top Ten category winner (Category Winner – Governance and
                Economic Contributions)
              </li>
            </ul>
          </div>

          {/* Chartered Accountants Annual Report Award – 2009 */}
          <div className="awards-section">
            <h2 className="section-title">
              Chartered Accountants Annual Report Award – 2009
            </h2>
            <ul className="awards-list">
              <li>Silver award (Service Sector)</li>
            </ul>
          </div>

          {/* Annual Forbes Financial Magazine List – 2010 */}
          <div className="awards-section">
            <h2 className="section-title">
              Annual Forbes Financial Magazine List – 2010
            </h2>
            <ul className="awards-list">
              <li>
                Distinction of being only one of two Sri Lankan Companies
                selected for the top 200 Asian firms with sales under a billion
                U.S. Dollars
              </li>
            </ul>
          </div>

          {/* National Chamber of Exporters (NCE) Export Award – 2009 */}
          <div className="awards-section">
            <h2 className="section-title">
              National Chamber of Exporters (NCE) Export Award – 2009
            </h2>
            <div className="awards-image-wrapper">
              <img
                src="/wp-content/uploads/2016/02/nce20101.jpg"
                alt="NCE Export Award 2009"
              />
            </div>
          </div>

          {/* National Chamber of Exporters (NCE) Export Award – 2009 (details) */}
          <div className="awards-section">
            <h2 className="section-title">
              National Chamber of Exporters (NCE) Export Award – 2009
            </h2>
            <ul className="awards-list">
              <li>
                Exporter of Business and Professional Services Sector – Extra
                Large Category (Gold)
              </li>
              <li>
                Most Outstanding Exporter – Export of Business and Professional
                Services Sector (Gold)
              </li>
              <li>Most Value Added Exporter (Gold)</li>
            </ul>
          </div>

          {/* National Chamber of Exporters (NCE) Export Award – 2007 */}
          <div className="awards-section">
            <h2 className="section-title">
              National Chamber of Exporters (NCE) Export Award – 2007
            </h2>
            <div className="awards-image-wrapper">
              <img
                src="/wp-content/uploads/2016/02/nce20071.jpg"
                alt="NCE Export Award 2007"
              />
            </div>
          </div>

          {/* Chartered Accountants Annual Report Awards 2012 */}
          <div className="awards-section">
            <h2 className="section-title">
              Chartered Accountants Annual Report Awards 2012
            </h2>
            <div className="awards-image-wrapper centered">
              <img
                src="/wp-content/uploads/2016/02/AnnualReportAwards_12.jpg"
                alt="Annual Report Awards 2012"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default AwardsPage;
